import React, { Component, Fragment } from "react";
import { inject, observer } from "mobx-react";
import { withRouter } from "react-router-dom";

import { Typography } from "@material-ui/core";

import Header from "../../components/Header";
import Sidebar from "../../components/Sidebar";
import MainContainer from "../../components/MainContainer";
import Breadcrumb from "../../components/Breadcrumb";
import Heading from "../../components/Heading";

import VenueHGSuperPayTab from "./VenueHGSuperPayTab";
import MvrIntroductionDialog from "../../components/superPay/MvrIntroductionDialog";

const breadcrumb = [{ name: "Manage" }, { name: "HG Super Pay" }];

class VenueHGSuperPayPage extends Component {
    render() {
        const profileId = this.props.match.params.id;
        const currentProfile = this.props.profileStore.getCurrentProfile();
        const { addonStatus } = this.props.hgSuperPayAddonStore;

        const badge =
            addonStatus === "loading"
                ? { label: "Checking…", color: "#6b7280", bg: "#eef0f3" }
                : addonStatus === "active"
                ? { label: "Active", color: "#15a36a", bg: "#e8f7ef" }
                : { label: "Inactive", color: "#6b7280", bg: "#eef0f3" };

        if (process.env.REACT_APP_DISABLE_BILLING_MOBILE === "true") {
            return (
                <Fragment>
                    <Header role={currentProfile && this.props.templateStore.getTypeString(currentProfile.type)} />
                    <Sidebar />
                    <MainContainer>
                        <Typography variant="display1" style={{ textAlign: "center", marginTop: 60, color: "#6b7280" }}>
                            This feature is only available on the desktop version.
                        </Typography>
                    </MainContainer>
                </Fragment>
            );
        }

        return (
            <Fragment>
                <Header
                    role={
                        currentProfile &&
                        this.props.templateStore.getTypeString(currentProfile.type)
                    }
                />
                <Sidebar />
                <MainContainer>
                    <Breadcrumb links={breadcrumb} />
                    <MvrIntroductionDialog />
                    <Heading title="HG Super Pay">
                        <span
                            style={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: 6,
                                fontSize: 12,
                                fontWeight: 600,
                                padding: "4px 10px",
                                borderRadius: 999,
                                background: badge.bg,
                                color: badge.color
                            }}
                        >
                            ● {badge.label}
                        </span>
                    </Heading>
                    <Typography variant="body1" style={{ color: "#6b7280", marginTop: -8, marginBottom: 18 }}>
                        Set up and manage superannuation payments for your sole-trader artists and players. Australian customers only.
                    </Typography>
                    <VenueHGSuperPayTab
                        profileId={profileId}
                        initialTab={this.props.match.params.returnStatus === "employees"
                            ? 2
                            : this.props.location.state && this.props.location.state.initialTab || 0}
                        navigationKey={this.props.location.key || this.props.location.pathname}
                    />
                </MainContainer>
            </Fragment>
        );
    }
}

export default inject(
    "profileStore",
    "templateStore",
    "hgSuperPayAddonStore"
)(withRouter(observer(VenueHGSuperPayPage)));
